// extracted by mini-css-extract-plugin
export default {"root":"_3XF3l","align-items-center":"_1sd0_","alignItemsCenter":"_1sd0_"};